import React, { FC, ReactNode, useContext, useRef } from 'react'
import s from './Cover.module.sass'
import { ImgContext } from '@shared/ui/Layout/Cover/Cover'
import { ErrorBoundary } from '../../../lib/components/ErrorBoundary'
import { useOnScreen } from '@widgets/Restaurant/Booking/lib/helper'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { MediaImg } from '@shared/ui/Media/MediaImg'

interface Props {
  children: ReactNode
  className?: string
  alt?: string
}

const CoverAside: FC<Props> = ({ children, className = '', alt = 'image cover' }) => {
  const { isMobile } = useClientResponsive()
  const imgSrc = useContext(ImgContext)
  const wrapper = useRef()
  const isVisible = useOnScreen(wrapper, { threshold: 0.15 })
  const imgSizes = {
    width: isMobile ? 400 : 900,
    height: isMobile ? 245 : 500,
  }
  return (
    <ErrorBoundary>
      <aside className={s['aside-wrapper']} data-visible={isMobile ? isVisible : true} ref={wrapper}>
        <div className={s['aside-container']}>
          <div className={`${s.aside} ${className}`}>
            <div className={s['aside-inner']}>
              <MediaImg
                image={{
                  Url: imgSrc,
                  Width: imgSizes.width,
                  Height: imgSizes.height,
                  Crop: null,
                  Description: alt,
                  Copyright: null,
                  Author: null,
                }}
                objectId={Number(imgSrc)}
                height={imgSizes.height}
                width={imgSizes.width}
                flexible={true}
                className={s.img}
              />
            </div>
            {children}
          </div>
        </div>
      </aside>
    </ErrorBoundary>
  )
}

export default CoverAside
